import { PureComponent } from 'react';
import type { PropsWithChildren } from 'react';
import { FormControl } from '@mui/material';
// This used to be imported from react-file-reader-input, but peer deps are still at react 15/16, so we
// just copied the code. At the time of writing, last update was 4 years ago (2022-05-12)
// For reference: https://www.npmjs.com/package/react-file-reader-input
import { FileReaderInput } from './FileReaderInput';

interface FileReaderInputFieldProps {
    className?: string;

    onUpload(files: File[]): void;
}

export class FileReaderInputField extends PureComponent<
    PropsWithChildren<FileReaderInputFieldProps>
> {
    render() {
        const { className, onUpload, children } = this.props;
        const fileReadSupported =
            window.FileReader && window.File && window.FileList && window.Blob;

        if (!fileReadSupported) {
            return <div>{'File upload not supported in your browser'}</div>;
        }
        return (
            <FormControl fullWidth className={className}>
                <FileReaderInput
                    as="binary"
                    id="my-file-input"
                    onUpload={onUpload}
                    data-testid="file-reader-input-field"
                >
                    {children}
                </FileReaderInput>
            </FormControl>
        );
    }
}

export default FileReaderInputField;
